import { render, staticRenderFns } from "./company-certifications-bonding.vue?vue&type=template&id=4a8b243e&"
import script from "./company-certifications-bonding.vue?vue&type=script&lang=js&"
export * from "./company-certifications-bonding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports